import {Component, Input} from '@angular/core';

@Component({
  selector: 'form-row',
  templateUrl: './form-row.component.html',
  styleUrls: ['./form-row.component.scss'],
})
export class FormRowComponent{

  @Input() formRowTitle: string;
  @Input() description: string;
  @Input() removeMargin = false;
  @Input() warnings: string[];

}
